import styled from 'styled-components';

export default styled.div`
  background-color: #ebebeb;
  color: #646972;
  display: flex;
  flex: 0 0 30px;
  font-size: 18px;
  justify-content: center;
  line-height: 12px;

  & > i {
    cursor: pointer;
  }

  user-select: none;
`;
